module.exports = __webpack_public_path__ + "img/back-yard.5a1b6e46.png";